import { useMutation } from "@apollo/client/react";
import { UPDATE_VERIFIER_POSITIONS } from "../../mutations/invoiceInterpretationTemplates/updateVerifierPositions";
import type { TemplateVerifierPositionsInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateVerifierPositions = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(UPDATE_VERIFIER_POSITIONS, {
    onCompleted,
    onError,
  });

  const updateVerifierPositions = async ({
    input,
    templateId,
    clientIdentifier,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    input: TemplateVerifierPositionsInput;
  }) => {
    return mutation({
      variables: { templateId, clientIdentifier, input },
    });
  };

  return { updateVerifierPositions, loading, error, data };
};
